import React, { forwardRef } from 'react'
import {default as MuiButton} from '@mui/material/Button'

const Button = forwardRef((props, ref) => {
  const {sx: sxOverrides, ...otherProps} = props
  const sx = {
    fontSize:'1rem',
    fontWeight:700,
    paddingY: '16px',
    ...sxOverrides,
  }

  return (
    <MuiButton
      ref={ref}
      sx={sx}
      {...otherProps}
    />
  )
})

export default Button
